import Vue from 'vue'
import Router from 'vue-router'
import Cases from '@/components/cases/Cases'
import CreateCase from '@/components/cases/CreateCase'
import CreationOrders from '@/components/cases/CreationOrders'
import UpdateCaseCreationOrder from '@/components/cases/UpdateCaseCreationOrder'
import store from '@/store'

Vue.use(Router)

export default new Router({
  //mode: 'history',
  routes: [
    {
      path: '/',
      component: Cases,
      beforeEnter (to, from, next) {
        next('/cases')
      }
    },
    {
      path: '/cases',
      name: 'cases',
      component: Cases
    },
    {
      path: '/cases/create',
      name: 'createCase',
      component: CreateCase
    },
    {
      path: '/cases/creation-orders',
      name: 'caseCreationOrders',
      component: CreationOrders
    },
    {
      path: '/cases/creation-orders/:id/update',
      name: 'updateCaseCreationOrder',
      component: UpdateCaseCreationOrder
    },
    {
      path: '/logout',
      name: 'logout',
      beforeEnter (to, from, next) {
        next('/')
      }
    }
  ]
})
